import { ActionTree } from 'vuex'

import { RootState } from '../state'
import invoicesActions from './invoices/actions'
import ordersActions from './orders/actions'
import orderPaymentsActions from './orderPayments/actions'

import { OrderingState } from './state'

import {
  RESET_INVOICES_QUERY_INDEX,
  RESET_LOADED_ALL_INVOICES,
  UPDATE_INVOICES,
  UPDATE_INVOICES_TOTAL
} from './invoices/mutations'

import {
  CLEAR_INVOICES_ORDERS,
  RESET_LOADED_ALL_ORDERS,
  RESET_ORDERS_QUERY_INDEX,
  UPDATE_ORDERS,
  UPDATE_ORDERS_TOTAL
} from './orders/mutations'

import {
  CLEAR_INVOICES_ORDER_PAYMENTS,
  UPDATE_ORDER_PAYMENTS
} from './orderPayments/mutations'

const actions: ActionTree<OrderingState, RootState> = {
  ...invoicesActions,
  ...ordersActions,
  ...orderPaymentsActions,

  /**
   * Clears the OrderingState.
   */
  logout ({ commit }) {
    commit(UPDATE_INVOICES, [])
    commit(UPDATE_INVOICES_TOTAL, 0)
    commit(RESET_LOADED_ALL_INVOICES)
    commit(RESET_INVOICES_QUERY_INDEX)

    commit(CLEAR_INVOICES_ORDERS)
    commit(UPDATE_ORDERS, [])
    commit(UPDATE_ORDERS_TOTAL, 0)
    commit(RESET_LOADED_ALL_ORDERS)
    commit(RESET_ORDERS_QUERY_INDEX)

    commit(CLEAR_INVOICES_ORDER_PAYMENTS)
    commit(UPDATE_ORDER_PAYMENTS, [])
  }
}

export default actions
